import { TTrackingType } from "./event-types";
import eventTrackingHandler from "./eventTrackingHandler";

export type TConfiguredTracker<TEvents extends string = string> = (
  event: TEvents,
  properties?: Record<string, unknown>,
) => void;

type TrackerOptions = {
  types?: TTrackingType[];
  defaultProperties?: Record<string, unknown>;
};

/**
 * @example
 * PricingService.init({
 *   track: createTrackerConfig<TPricingEvent>(rawTrack, {
 *     types: ["posthog", "customerio"],
 *     defaultProperties: BASE_PSP_EVENT_PROPS,
 *   }),
 * });
 */
export function createTrackerConfig<TEvents extends string = string>(
  rawTrack: typeof eventTrackingHandler,
  options: TrackerOptions = {},
): TConfiguredTracker<TEvents> {
  return (event, properties) => {
    rawTrack(event, {
      types: options.types,
      properties: { ...options.defaultProperties, ...properties },
    });
  };
}
